import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Articles',
    href: '#articles'
  }, {
    name: 'Media',
    href: '#media'
  }, {
    name: 'Experience',
    href: '#experience'
  }, {
    name: 'Work History',
    href: '#work-history'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <header className={`fixed top-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-154">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-155">
        <div className="flex justify-between items-center" data-id="element-156">
          <div className="flex-shrink-0 flex items-center" data-id="element-157">
            <a href="#hero" data-id="element-158">
              <span className={`font-semibold text-xl tracking-tight ${isScrolled ? 'text-slate-900' : 'text-slate-800'}`} data-id="element-159">
                Arthur Miller
              </span>
            </a>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden md:flex space-x-8" data-id="element-160">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-slate-600 hover:text-blue-600 transition-colors" data-id="element-161">
                {link.name}
              </a>)}
          </nav>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center" data-id="element-162">
            <button onClick={() => setIsOpen(!isOpen)} className="text-slate-600 hover:text-slate-900 focus:outline-none" aria-label="Toggle menu" data-id="element-163">
              {isOpen ? <X className="h-6 w-6" data-id="element-164" /> : <Menu className="h-6 w-6" data-id="element-165" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav */}
      {isOpen && <div className="md:hidden absolute top-full left-0 w-full bg-white shadow-lg border-t border-slate-100" data-id="element-166">
          <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-167">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsOpen(false)} className="block px-3 py-3 text-base font-medium text-slate-700 hover:text-blue-600 hover:bg-slate-50 rounded-md" data-id="element-168">
                {link.name}
              </a>)}
          </div>
        </div>}
    </header>;
}